import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Clock } from 'lucide-react';
import { toast } from 'sonner';
import { apiClient } from '@/lib/api-client';

const TTL_OPTIONS = [
  { value: 300, label: '5 minut' },
  { value: 900, label: '15 minut' },
  { value: 1800, label: '30 minut' },
  { value: 3600, label: '1 hodina' },
];

type SettingsResponse = Record<string, string | undefined>;

export default function CacheSettings() {
  const [ttl, setTtl] = useState(300);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiClient
      .get<SettingsResponse>('/settings')
      .then((s) => setTtl(parseInt(s.cache_ttl_seconds ?? '300', 10)))
      .catch(() => {});
  }, []);

  const handleChange = async (val: string | null) => {
    if (!val) return;
    const num = parseInt(val, 10);
    setTtl(num);
    setSaving(true);
    try {
      await apiClient.patch<SettingsResponse>('/settings', { cache_ttl_seconds: String(num) });
      toast.success('Nastavení uloženo');
    } catch {
      toast.error('Nepodařilo se uložit');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Clock className="h-4 w-4 text-primary" />
          Cache
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-xs text-muted-foreground mb-2">
          Doba cachování dat z Google Sheets {saving && <span className="text-[var(--primary)]">(ukládání...)</span>}
        </p>
        <Select value={String(ttl)} onValueChange={handleChange}>
          <SelectTrigger className="w-[200px]">
            <SelectValue>
              {(v: string) => TTL_OPTIONS.find((o) => String(o.value) === v)?.label ?? v}
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            {TTL_OPTIONS.map((opt) => (
              <SelectItem key={opt.value} value={String(opt.value)}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </CardContent>
    </Card>
  );
}
